<div (click)="$event.stopPropagation()">
  <child-header title="Sales Documents" (closeEvent)="closePage()"></child-header>

  <!-- <div class="pageTitle">
    <i class="material-icons closebutton-pullfloat-right" (click)="closePage()">close</i>
    <h1 class="profile-header">SALES DOCUMENT</h1>
  </div> -->
  <div class="child-body my-sale-doc">
  <div class="component-wrapper">
    <!-- <div class="title blade-title-font blade-title-position">
      Sales Documents
    </div> -->
    <div class="note">
      Please send me the documents below as they are available
    </div>
    <div class="form-check">
      <mat-checkbox [(ngModel)]="userInfo.invoices">
        Invoices
      </mat-checkbox>
      <div class="row support-text">Adobe PDF</div>
      
    </div>

    <div class="form-check">
      <mat-checkbox [(ngModel)]="userInfo.orderConfs">
          Order confirmations
      </mat-checkbox>
      <div class="row support-text">Adobe PDF</div>
    </div>

    <div class="form-check">
      <mat-checkbox [(ngModel)]="userInfo.orderStatusUpdates">
          Order status updates
          
        </mat-checkbox>
        <div class="row support-text">Adobe PDF</div>
    </div>

    <div class="form-check">
      <mat-checkbox [(ngModel)]="userInfo.etaUpdates">
          Back order ETA updates
          
        </mat-checkbox>
        <div class="row support-text">HTML email with attached Excel .csv</div>
    </div>

    <div class="form-check">
      <mat-checkbox [(ngModel)]="userInfo.annuityExpireUpdates">
          Annuity expiry updates
          
        </mat-checkbox>
        <div class="row support-text">HTML email</div>
    </div>

    <div class="form-check">
      <mat-checkbox [(ngModel)]="userInfo.shippingReports">
          Shipping report
          
        </mat-checkbox>
        <div class="row support-text">HTML email with attached Excel .csv</div>
    </div>

    <div class="form-check">
      <mat-checkbox [(ngModel)]="userInfo.statements">
          Statements
          
        </mat-checkbox>
        <div class="row support-text">Adobe PDF</div>
    </div>

    <button class="button button-red button-large" (click)="updateSalesDocuments()">Update sales documents</button>
  </div>
  </div>
</div>